import React, { useState } from 'react'
import './Navbar.css'
import { BiSearchAlt2 } from "react-icons/bi";
import { HiShoppingCart } from "react-icons/hi";
import { FaUserAlt } from "react-icons/fa";
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import { RxHamburgerMenu } from "react-icons/rx";
import { RiAccountCircleFill } from "react-icons/ri";
import { ImCancelCircle } from "react-icons/im";
import { SiHomeadvisor } from "react-icons/si";
import { BsEyeglasses, BsSunglasses, BsTelephoneInbound } from "react-icons/bs";
import { GiHypodermicTest } from "react-icons/gi";
import { CiDiscount1 } from "react-icons/ci";
import { GiSpectacleLenses } from "react-icons/gi";
import { IoGlassesOutline } from "react-icons/io5";
import { useNavigate, Outlet, Link } from 'react-router-dom';
import blinkk_logo from '../images/blinkk_logo.png'
import LoginPagefrom from '../login/LoginPage'


export default function Navbar() {
  const [isLoginShown, setisLoginShown] = useState(false)
  const navigate = useNavigate();

  const handleMenu = () => {
    document.getElementById('detailsPopup').classList.remove('hidden');
    document.getElementById('root').classList.add('black_background')
    document.getElementById('root').classList.add('black_background_position');
    let listOfwhitearea = document.getElementsByClassName('gender')
    for (let i = 0; i < listOfwhitearea.length; i++) {
      listOfwhitearea[i].classList.add('black_background')
    }
  }

  const hanldeSearchUI = () => {
    navigate('/search');
  }

  const handleSignUI = () => {
    document.getElementById('detailsPopup').classList.add('hidden');
    setisLoginShown(true);
    setTimeout(() => {
      document.getElementsByClassName('login_ui')[0].classList.remove('hidden')
      document.getElementById('root').classList.add('black_background')
      document.getElementById('root').classList.add('black_background_position');
      let listOfwhitearea = document.getElementsByClassName('gender')
      for (let i = 0; i < listOfwhitearea.length; i++) {
        listOfwhitearea[i].classList.add('black_background')
      }
    }, 1);

  }

  const handleClosePopup = () => {
    document.getElementById('detailsPopup').classList.add('hidden');
    document.getElementById('root').classList.remove('black_background');
    document.getElementById('root').classList.remove('black_background_position');
    let listOfwhitearea = document.getElementsByClassName('gender')
    for (let i = 0; i < listOfwhitearea.length; i++) {
      listOfwhitearea[i].classList.remove('black_background')
    }
  }
  return (
    <div className='heading'>
      {isLoginShown && (
        <div className='login_ui'>
          <LoginPagefrom />
        </div>
      )}
      <div className='details_menu hidden' id='detailsPopup'>
        <div className='account_card' >
          <RiAccountCircleFill className='user_account_popup_icon' />
          <div className='welcome_sign'>
            <p className='welcome_text'>Welcome</p>
            <p className='sign_in' onClick={handleSignUI}>Sign In/ Sign Up</p>
          </div>
          <ImCancelCircle className='close_btn' onClick={handleClosePopup} />
        </div>
        <div className='single_widget'>
          <SiHomeadvisor className='popup_icon' />
          <p>Home</p>
        </div>
        <div className='single_widget'>
          <BsEyeglasses className='popup_icon' />
          <p>Eyeglasses</p>
        </div>
        <div className='single_widget'>
          <BsSunglasses className='popup_icon' />
          <p>Sunglass</p>
        </div>
        <div className='single_widget'>
          <GiSpectacleLenses className='popup_icon' />
          <p>Contact Lens</p>
        </div>
        <div className='single_widget'>
          <IoGlassesOutline className='popup_icon' />
          <p>Kids Glass</p>
        </div>
        <div className='single_widget'>
          <GiHypodermicTest className='popup_icon' />
          <p>Home Eye Test</p>
        </div>
        <div className='single_widget'>
          <CiDiscount1 className='popup_icon' />
          <p>Offers</p>
        </div>
        <div className='single_widget'>
          <BsTelephoneInbound className='popup_icon' />
          <p>Contact us</p>
        </div>
      </div>
      <div className='nav_menu'>
        <RxHamburgerMenu className='menu_hamburger' onClick={handleMenu} />
        <div className='blink_nav_logo'>
          <img src={blinkk_logo} alt='blinkk' />
          <div className='search_bar'>
            <form>
              <input type="text" name="search" className='search_item' />
            </form>
            <BiSearchAlt2 className='search_icons' />
          </div>
        </div>
      </div>
      <div className='leftside'>
        <BiSearchAlt2 className=' search_icons search_icons_mbl_view' onClick={hanldeSearchUI} />
        <div className='cart_account' >
          <div className='cart'>
            <HiShoppingCart className='icons' />
            <p>(0)</p>
            <FaUserAlt className='icons user_account' />
          </div>
        </div>
      </div>
    </div>
  )
}
